export interface EpisodeCharacter {
  name: string;
  role: string;
  desc: string;
}

export interface Episode {
  id: string;
  number: number;
  title: string;
  subtitle: string;
  cover: string;
  duration: string;
  releaseDate: string;
  status: '已更新' | '待更新';
  tags: string[];
  summary: string;
  synopsis: string[];
  characters: EpisodeCharacter[];
}

export interface Recommendation {
  id: string;
  title: string;
  cover: string;
  genre: string;
  rating: string;
  desc: string;
}

export const episodes: Episode[] = [
  {
    id: 'ep-01',
    number: 1,
    title: '第1集 · 无颜之月的少女',
    subtitle: 'The Girl Without a Face',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20key%20visual%20of%20a%20moonlit%20coastal%20town%20at%20night%2C%20mysterious%20girl%20in%20a%20flowing%20white%20dress%20standing%20on%20a%20rooftop%2C%20deep%20navy%20and%20violet%20atmosphere%2C%20glowing%20embers%2C%20dramatic%20backlight%2C%20film%20poster%20composition%2C%20highly%20detailed%20artwork%2C%20moody%20and%20ethereal&width=640&height=360&seq=wyy-ep-01&orientation=landscape',
    duration: '24:05',
    releaseDate: '2025-01-08',
    status: '已更新',
    tags: ['悬疑', '奇幻', '月夜'],
    summary: '月圆之夜，一名没有面孔的少女出现在临海小城，打破了主角平静的生活。',
    synopsis: [
      '临海小城「汐见町」迎来一年一度的月见祭，灯火与潮声交织成一片朦胧的夜色。高中生冬月澈在放学回家的路上，第一次看见了那个站在钟楼顶端的少女——她的面容被月光完全抹去，只留下轮廓与随风轻扬的白裙。',
      '少女似乎记得澈的名字，却说不清自己从何而来。那一夜过后，小城里开始出现「被人遗忘」的怪事：邻居、同学、甚至街角的旧书店，都在悄无声息地从人们的记忆中消失。',
      '澈带着困惑与不安，决定追寻这名「无颜之月」少女的来历。他隐约意识到，自己或许也早已站在被遗忘的边缘。',
    ],
    characters: [
      { name: '冬月 澈', role: '男主', desc: '性格内敛的转学生，对消失的记忆异常敏感。' },
      { name: '月见 铃', role: '女主', desc: '面容被月光抹去的少女，身份成谜。' },
    ],
  },
  {
    id: 'ep-02',
    number: 2,
    title: '第2集 · 灯火祭的约定',
    subtitle: 'Promise of the Lantern Night',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20traditional%20Japanese%20lantern%20festival%20at%20night%2C%20crowds%20in%20yukata%2C%20glowing%20red%20and%20violet%20lanterns%20floating%20over%20a%20river%2C%20deep%20navy%20sky%2C%20warm%20sparks%2C%20emotional%20film%20poster%20composition%2C%20richly%20detailed%20illustration%20artwork%2C%20dreamy%20atmosphere&width=640&height=360&seq=wyy-ep-02&orientation=landscape',
    duration: '23:48',
    releaseDate: '2025-01-15',
    status: '已更新',
    tags: ['奇幻', '日常', '祭典'],
    summary: '在灯火祭的河畔，铃许下了一个连她自己都无法理解的约定。',
    synopsis: [
      '为了让铃融入人群，澈带她参加了汐见町的灯火祭。漫天的灯盏顺流而下，映在铃没有五官的脸上，竟泛起淡淡的微光，这让澈第一次感到她并非完全「不存在」。',
      '祭典途中，一位摆摊的老婆婆叫住了铃，说她与百年前的一位姑娘长得一模一样。婆婆递给她一枚旧得发暗的铜铃，铃在触碰到它的瞬间说出了三个字：「别忘记我。」',
      '那句约定像钥匙一样，让澈的脑海中闪过一段陌生又熟悉的记忆碎片。回家的路上，两人之间多了一份说不清的羁绊。',
    ],
    characters: [
      { name: '月见 铃', role: '女主', desc: '在祭典中显露出不为人知的过往线索。' },
      { name: '蓝婆', role: '配角', desc: '街边摆摊的老婆婆，仿佛知道更多秘密。' },
    ],
  },
  {
    id: 'ep-03',
    number: 3,
    title: '第3集 · 雨夜的站台',
    subtitle: 'Platform in the Rain',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20an%20empty%20rural%20train%20station%20platform%20on%20a%20rainy%20night%2C%20wet%20reflective%20ground%2C%20a%20lone%20figure%20holding%20an%20umbrella%20under%20a%20rainbow%20of%20blue%20and%20purple%20lights%2C%20melancholic%20mood%2C%20film%20poster%20composition%2C%20detailed%20atmospheric%20artwork&width=640&height=360&seq=wyy-ep-03&orientation=landscape',
    duration: '24:12',
    releaseDate: '2025-01-22',
    status: '已更新',
    tags: ['悬疑', '情感'],
    summary: '末班车迟迟不来，站台上只剩下澈、铃，以及一个不该存在的人。',
    synopsis: [
      '暴雨的夜里，澈陪着铃去车站寻找她记忆中「第一次出现」的地方。空无一人的站台回荡着雨声，广播反复播报着一班早已停运的列车。',
      '就在这时，一位自称是车站站务员的男子出现了，他声称自己正在等一个「十年前没能上车的人」。奇怪的是，铃对这名男子毫无印象，澈却觉得他无比熟悉。',
      '当列车终于驶入站台，车门打开的瞬间，澈看到了车厢里空荡荡的座位——以及车窗上倒映出的、与自己一模一样却带着微笑的另一张脸。',
    ],
    characters: [
      { name: '冬月 澈', role: '男主', desc: '开始怀疑自己的记忆是否真实。' },
      { name: '站务员', role: '配角', desc: '神秘男子，苦等一班不存在的列车。' },
    ],
  },
  {
    id: 'ep-04',
    number: 4,
    title: '第4集 · 会飞的书页',
    subtitle: 'The Flying Pages',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20vintage%20library%20at%20night%20with%20floating%20books%20and%20glowing%20pages%20spiraling%20in%20the%20air%2C%20purple%20magical%20light%2C%20tall%20wooden%20shelves%2C%20a%20silhouette%20reading%2C%20deep%20blue%20shadows%2C%20film%20poster%20composition%2C%20highly%20detailed%20artwork&width=640&height=360&seq=wyy-ep-04&orientation=landscape',
    duration: '23:55',
    releaseDate: '2025-01-29',
    status: '已更新',
    tags: ['奇幻', '悬疑', '图书馆'],
    summary: '旧书店的藏书在午夜自行翻页，书中记录着这座小城被抹去的名字。',
    synopsis: [
      '为了查明「消失」的真相，澈和铃来到街角那家快要关门的老书店。店主是个眼神疲惫的中年人，他递给澈一本没有书名的旧册子。',
      '翻开的瞬间，书页像有生命般漫天飞舞，每一页上都写着一个人名和一段被划去的记忆。澈在最后一页看到了自己的名字，日期却是空白的。',
      '铃伸手接住其中一页，纸上浮现出她自己的轮廓——原来这本书并不是记录别人，而是记录「被遗忘者」的名册。',
    ],
    characters: [
      { name: '旧书店店主', role: '配角', desc: '守着名册多年的沉默中年人。' },
      { name: '月见 铃', role: '女主', desc: '在名册上找到了与自己相关的画像。' },
    ],
  },
  {
    id: 'ep-05',
    number: 5,
    title: '第5集 · 雪中的神社',
    subtitle: 'Shrine in the Snow',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20snow%20covered%20mountainside%20shrine%20at%20twilight%2C%20red%20torii%20gates%20under%20falling%20snow%2C%20blue%20violet%20twilight%20sky%2C%20a%20lonely%20figure%20climbing%20stone%20stairs%2C%20frozen%20stillness%2C%20film%20poster%20composition%2C%20detailed%20painterly%20artwork&width=640&height=360&seq=wyy-ep-05&orientation=landscape',
    duration: '24:02',
    releaseDate: '2025-02-05',
    status: '已更新',
    tags: ['奇幻', '神社', '静谧'],
    summary: '雪山深处的神社里，供奉着一位被时间遗忘的神明。',
    synopsis: [
      '线索指向城外的白山神社。澈独自踏上积雪的山道，铃却在中途停下脚步，说山下有「不能上去的东西」。',
      '神社的殿内空无一人，只有一盏长明灯和一卷古老的绘卷。绘卷上画着百年前的那个月圆之夜，一名少女为了拯救整座小城，主动献出了自己的面容与名字。',
      '澈终于明白了铃的来历，也明白了那个「别忘记我」的约定究竟意味着什么。下山时，铃的轮廓似乎比来时又淡了一分。',
    ],
    characters: [
      { name: '月见 铃', role: '女主', desc: '献出面容与名字的少女的化身。' },
      { name: '白山神主', role: '配角', desc: '守护绘卷的神秘神主。' },
    ],
  },
  {
    id: 'ep-06',
    number: 6,
    title: '第6集 · 黄昏的天台',
    subtitle: 'Rooftop at Dusk',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20school%20rooftop%20at%20dusk%20overlooking%20the%20sea%2C%20two%20students%20standing%20apart%20in%20silhouette%2C%20vivid%20orange%20sunset%20fading%20into%20deep%20blue%20and%20violet%20sky%2C%20wind%20in%20the%20air%2C%20bittersweet%20mood%2C%20film%20poster%20composition%2C%20detailed%20artwork&width=640&height=360&seq=wyy-ep-06&orientation=landscape',
    duration: '23:50',
    releaseDate: '2025-02-12',
    status: '已更新',
    tags: ['情感', '青春的'],
    summary: '黄昏的余晖下，澈第一次向铃说出了自己真正的心意。',
    synopsis: [
      '自从神社归来，铃变得愈发沉默。澈带她回到学校，邀请她在放学后的天台看海。夕阳把整片海面染成橙红，又慢慢沉入深蓝的夜色。',
      '澈终于说出了那句藏了很久的话：他不想忘记她，也不想让她再独自承受一切。铃沉默了很久，才轻声回答：「记住我，本身就是一种代价。」',
      '两人的距离在这一刻被拉近，而天空最后一缕余晖消失时，钟楼的钟声再次响起——这是「抹去」即将开始的信号。',
    ],
    characters: [
      { name: '冬月 澈', role: '男主', desc: '下定决心要守住与铃的记忆。' },
      { name: '月见 铃', role: '女主', desc: '坦然面对自己注定被遗忘的命运。' },
    ],
  },
  {
    id: 'ep-07',
    number: 7,
    title: '第7集 · 水底的钟声',
    subtitle: 'Bells Beneath the Water',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20submerged%20underwater%20cavern%20with%20glowing%20blue%20crystal%20formations%20and%20an%20old%20sunken%20bell%2C%20rays%20of%20moonlight%20from%20above%2C%20mysterious%20deep%20ocean%20violet%20glow%2C%20ethereal%20and%20haunting%2C%20film%20poster%20composition%2C%20highly%20detailed%20artwork&width=640&height=360&seq=wyy-ep-07&orientation=landscape',
    duration: '24:08',
    releaseDate: '2025-02-19',
    status: '已更新',
    tags: ['悬疑', '奇幻', '深海'],
    summary: '海湾深处沉睡着一口钟，钟声能唤醒被抹去的记忆。',
    synopsis: [
      '钟楼的钟声来自深海。澈与铃在废弃的码头潜入海中，发现湖底藏着一座被海水淹没的旧神社，中央悬着一口布满藤壶的青铜钟。',
      '当澈触碰钟身，整片海水泛起幽蓝的光，无数被遗忘的记忆化作气泡涌现：铃的过去、小城的秘密、以及那个百年前月圆之夜真正的抉择。',
      '浮出水面时，澈发现岸上的时间几乎没有流动——仿佛整个世界都在为他们的这次相遇按下了暂停键。',
    ],
    characters: [
      { name: '冬月 澈', role: '男主', desc: '亲眼看见了被尘封的真相。' },
      { name: '月见 铃', role: '女主', desc: '记忆随着钟声逐渐完整。' },
    ],
  },
  {
    id: 'ep-08',
    number: 8,
    title: '第8集 · 蓝色走廊',
    subtitle: 'The Blue Corridor',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20long%20empty%20school%20corridor%20at%20blue%20hour%2C%20warm%20evening%20light%20through%20windows%20casting%20long%20shadows%2C%20a%20single%20student%20walking%20away%2C%20deep%20blue%20and%20violet%20tones%2C%20nostalgic%20melancholy%2C%20film%20poster%20composition%2C%20detailed%20artwork&width=640&height=360&seq=wyy-ep-08&orientation=landscape',
    duration: '23:44',
    releaseDate: '2025-02-26',
    status: '已更新',
    tags: ['悬疑', '日常'],
    summary: '走廊尽头的那间教室，只在特定的人眼中才会出现。',
    synopsis: [
      '记忆开始出现裂缝后，澈发现自己能看见一条平时不存在的走廊。走廊尽头是一间挂着「月见」名牌的教室。',
      '教室里坐满了没有面孔的学生，唯有讲台上的老师保留着清晰的五官——那是澈小时候记忆中已经去世的母亲。',
      '母亲告诉他，这座小城的时间一直在为一次「约定」循环，而澈与铃，正是打破循环的关键。真相揭晓的同时，走廊开始一寸寸崩塌。',
    ],
    characters: [
      { name: '冬月 澈', role: '男主', desc: '见到了记忆中已逝的母亲。' },
      { name: '澈的母亲', role: '配角', desc: '揭示循环真相的关键人物。' },
    ],
  },
  {
    id: 'ep-09',
    number: 9,
    title: '第9集 · 风暴之崖',
    subtitle: 'Cliff of the Storm',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20dramatic%20sea%20cliff%20during%20a%20night%20storm%2C%20huge%20crashing%20waves%2C%20a%20lone%20figure%20standing%20at%20the%20edge%2C%20lightning%20illuminating%20deep%20blue%20and%20purple%20clouds%2C%20intense%20emotional%20mood%2C%20film%20poster%20composition%2C%20detailed%20cinematic%20artwork&width=640&height=360&seq=wyy-ep-09&orientation=landscape',
    duration: '24:16',
    releaseDate: '2025-03-05',
    status: '已更新',
    tags: ['高潮', '情感', '风暴'],
    summary: '风暴之夜，铃决定以自己的消失换回整座小城的记忆。',
    synopsis: [
      '最后一个月圆之夜逼近，小城的「消失」愈演愈烈。铃告诉澈，只有她彻底消失，才能终止循环，让所有人的记忆恢复如初。',
      '风暴笼罩着海岸，两人在崖顶争执。澈拼命想要留住她，却发现自己的手正穿透过铃逐渐透明的身影。',
      '雷声轰鸣之中，铃最后一次唤了澈的名字，微笑着走向崖边。澈伸出手，却只抓住了一缕被雨水打湿的月光。',
    ],
    characters: [
      { name: '月见 铃', role: '女主', desc: '以自我消失为代价终结循环。' },
      { name: '冬月 澈', role: '男主', desc: '目睹爱人消逝却无能为力。' },
    ],
  },
  {
    id: 'ep-10',
    number: 10,
    title: '第10集 · 镜中无面',
    subtitle: 'Faceless in the Mirror',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20room%20filled%20with%20tall%20antique%20mirrors%20reflecting%20an%20endless%20faceless%20figure%2C%20violet%20glow%2C%20cracked%20glass%20shards%20floating%2C%20surreal%20and%20mysterious%20deep%20blue%20atmosphere%2C%20film%20poster%20composition%2C%20highly%20detailed%20artwork&width=640&height=360&seq=wyy-ep-10&orientation=landscape',
    duration: '23:52',
    releaseDate: '2025-03-12',
    status: '已更新',
    tags: ['悬疑', '奇幻', '心理'],
    summary: '铃消失后，澈在镜子迷宫里遇见了另一个「自己」。',
    synopsis: [
      '铃消失后，世界仿佛恢复了正常，只有澈记得她存在过。为了找回铃，他再次潜入那家旧书店，却发现自己被拖进了一间布满镜子的空间。',
      '镜中的澈有的没有面容，有的带着诡笑，每一面镜子都对应着一次「被抹去」的可能。真正的澈必须在这些倒影中找出唯一还保有铃记忆的那一个。',
      '当他终于认清自己时，镜子尽数碎裂，碎片中浮现出铃留下的最后一句话：「到月亮那边来找我。」',
    ],
    characters: [
      { name: '冬月 澈', role: '男主', desc: '在镜之世界中直面自己被遗忘的可能。' },
      { name: '镜中之影', role: '配角', desc: '澈被抹去记忆后的各种倒影。' },
    ],
  },
  {
    id: 'ep-11',
    number: 11,
    title: '第11集 · 燃尽的月见祭',
    subtitle: 'The Lantern Night Burns',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20battle%20scene%20at%20night%2C%20embers%20and%20orange%20sparks%20flying%20above%20a%20burning%20festival%20street%2C%20glowing%20amber%20light%20against%20deep%20blue%20and%20violet%20sky%2C%20silhouettes%20of%20figures%20in%20conflict%2C%20dramatic%20high%20energy%20mood%2C%20film%20poster%20composition%2C%20detailed%20artwork&width=640&height=360&seq=wyy-ep-11&orientation=landscape',
    duration: '24:20',
    releaseDate: '2025-03-19',
    status: '已更新',
    tags: ['高潮', '战斗', '祭典'],
    summary: '为了留住记忆，澈在月见祭之夜向循环本身宣战。',
    synopsis: [
      '澈明白了循环的规则：只要还有人记得铃，「消失」就无法完成。他选择在第二年的月见祭上，当着整座小城的面念出铃的名字。',
      '祭典的灯火骤然失控，化作吞噬记忆的烈焰。神秘的神主现身阻拦，澄澈与他对峙——这一战不只是为了铃，也是为了所有被遗忘的人。',
      '燃尽的灯盏纷纷坠落，澈在火光中看见了铃归来的轮廓。循环，终于出现了第一道裂缝。',
    ],
    characters: [
      { name: '冬月 澈', role: '男主', desc: '以整座小城的记忆为赌注发起挑战。' },
      { name: '白山神主', role: '反派', desc: '维护循环秩序的守护者。' },
    ],
  },
  {
    id: 'ep-12',
    number: 12,
    title: '第12集 · 月圆之约',
    subtitle: 'Promise Under the Full Moon',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20finale%20scene%20of%20two%20figures%20reuniting%20on%20a%20clifftop%20under%20an%20enormous%20full%20moon%2C%20glowing%20violet%20and%20blue%20night%20sky%2C%20soft%20orange%20embers%20drifting%2C%20emotional%20hopeful%20ending%2C%20film%20poster%20composition%2C%20highly%20detailed%20emotional%20artwork&width=640&height=360&seq=wyy-ep-12&orientation=landscape',
    duration: '26:10',
    releaseDate: '2025-03-26',
    status: '待更新',
    tags: ['完结', '情感', '月夜'],
    summary: '循环撕裂的最后一夜，澈与铃在满月下许下了跨越时间的约定。',
    synopsis: [
      '第二年的满月之夜，循环在澈的努力下终于动摇。整座小城的人们在同一刻想起了那个没有面孔的少女，记忆如潮水般涌回。',
      '崖顶之上，铃的身影在月光中重新凝实。她依旧没有面容，却第一次让澈「看见」了她的微笑——那是一种比任何五官都更清晰的表情。',
      '两人没有许下宏大的誓言，只是约定：无论时间如何轮回，都要在每一个满月之夜，记得对方的名字。',
    ],
    characters: [
      { name: '冬月 澈', role: '男主', desc: '用记忆守住了与铃的约定。' },
      { name: '月见 铃', role: '女主', desc: '在满月下重新回到澈的身边。' },
    ],
  },
];

export const recommendations: Recommendation[] = [
  {
    id: 'rec-01',
    title: '月影回廊',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20poster%20of%20a%20mysterious%20girl%20in%20a%20dark%20corridor%20lit%20by%20violet%20moonlight%2C%20deep%20blue%20and%20purple%20atmosphere%2C%20glowing%20ornate%20details%2C%20supernatural%20mystery%2C%20elegant%20vertical%20poster%20composition%2C%20highly%20detailed%20illustration%20artwork&width=520&height=740&seq=wyy-rec-01&orientation=portrait',
    genre: '悬疑 / 奇幻',
    rating: '9.1',
    desc: '在循环往复的长廊里，她一遍遍寻找那个被人遗忘的约定。',
  },
  {
    id: 'rec-02',
    title: '潮汐钟摆',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20poster%20of%20a%20lighthouse%20tower%20at%20night%20surrounded%20by%20tidal%20waves%2C%20deep%20navy%20and%20violet%20sky%2C%20glowing%20amber%20beacon%2C%20melancholic%20romance%20mood%2C%20elegant%20vertical%20poster%20composition%2C%20detailed%20painterly%20artwork&width=520&height=740&seq=wyy-rec-02&orientation=portrait',
    genre: '情感 / 治愈',
    rating: '8.7',
    desc: '灯塔守夜人与归航少女之间，一段随潮汐起落的约定。',
  },
  {
    id: 'rec-03',
    title: '纸上星辰',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20poster%20of%20a%20boy%20and%20floating%20glowing%20pages%20forming%20a%20starry%20sky%2C%20deep%20blue%20and%20purple%20nebula%2C%20magical%20fantasy%20mood%2C%20elegant%20vertical%20poster%20composition%2C%20highly%20detailed%20illustration%20artwork&width=520&height=740&seq=wyy-rec-03&orientation=portrait',
    genre: '奇幻 / 校园',
    rating: '8.9',
    desc: '能把故事写在星空上的少年，遇见了读不到自己结局的少女。',
  },
  {
    id: 'rec-04',
    title: '无声的烟花',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20poster%20of%20a%20lone%20girl%20watching%20fireworks%20over%20a%20silent%20town%20at%20night%2C%20warm%20orange%20bursts%20against%20deep%20blue%20violet%20sky%2C%20bittersweet%20emotional%20mood%2C%20elegant%20vertical%20poster%20composition%2C%20detailed%20artwork&width=520&height=740&seq=wyy-rec-04&orientation=portrait',
    genre: '情感 / 剧情',
    rating: '9.0',
    desc: '听不见声音的她，却在烟花绽放时读懂了所有人的心事。',
  },
  {
    id: 'rec-05',
    title: '第七种黄昏',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20poster%20of%20a%20city%20frozen%20in%20an%20endless%20sunset%2C%20orange%20gradient%20melting%20into%20deep%20blue%20and%20violet%2C%20lone%20walking%20figure%2C%20surreal%20sci-fi%20mystery%20mood%2C%20elegant%20vertical%20poster%20composition%2C%20highly%20detailed%20artwork&width=520&height=740&seq=wyy-rec-05&orientation=portrait',
    genre: '科幻 / 悬疑',
    rating: '8.6',
    desc: '当黄昏停在这一天，整座城市都被困在了同一个傍晚。',
  },
  {
    id: 'rec-06',
    title: '深海的信',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20anime%20poster%20of%20a%20glass%20bottle%20letter%20drifting%20in%20deep%20ocean%20with%20glowing%20blue%20and%20violet%20light%2C%20fish%20silhouettes%2C%20mysterious%20melancholic%20mood%2C%20elegant%20vertical%20poster%20composition%2C%20detailed%20illustration%20artwork&width=520&height=740&seq=wyy-rec-06&orientation=portrait',
    genre: '悬疑 / 情感',
    rating: '8.8',
    desc: '一封寄往海底的信，牵引出两个时空之间的回声。',
  },
];